import React, { useState } from "react";
import { FiUser, FiLock, FiEye, FiEyeOff, FiTrash2 } from "react-icons/fi";

export default function ProfilePage() {
  const [fullName, setFullName] = useState("asqarjon");
  const [email, setEmail] = useState("");
  const [phone] = useState("+998934409030");

  const [currentPass, setCurrentPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleProfileSave = (e) => {
    e.preventDefault();
    console.log("PROFILE UPDATE:", { fullName, email });
  };

  const handlePasswordSave = (e) => {
    e.preventDefault();
    console.log("PASSWORD CHANGE:", { currentPass, newPass, confirmPass });
  };

  const handleDeleteAccount = () => {
    if (window.confirm("Hisobni o‘chirmoqchimisiz?")) {
      console.log("ACCOUNT DELETE");
    }
  };

  return (
    <main className="min-h-screen bg-gray-50 py-10 sm:py-12">
      <div className="max-w-5xl mx-auto px-4">
        {/* Title */}
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900">
            Profil sozlamalari
          </h1>
          <p className="mt-2 text-sm text-gray-500 max-w-xl">
            Hisob ma’lumotlaringiz va xavfsizlik sozlamalarini boshqaring
          </p>
        </div>

        {/* Two columns */}
        <div className="grid gap-8 md:grid-cols-2">
          {/* LEFT – Shaxsiy ma'lumotlar */}
          <section className="bg-white rounded-2xl border border-gray-200 shadow-sm px-6 py-6 sm:px-8 sm:py-7">
            <h2 className="text-base font-semibold text-gray-900">
              Shaxsiy ma&apos;lumotlar
            </h2>
            <p className="mt-1 text-xs text-gray-500">
              Ismingiz va email manzilingizni yangilang
            </p>

            <form onSubmit={handleProfileSave} className="mt-5 space-y-4">
              {/* Full name */}
              <div>
                <label className="text-xs font-medium text-gray-700 block mb-1.5">
                  To&apos;liq ism
                </label>
                <input
                  type="text"
                  className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm bg-gray-50 focus:bg-white focus:border-black focus:ring-1 focus:ring-black outline-none"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </div>

              {/* Email */}
              <div>
                <label className="text-xs font-medium text-gray-700 block mb-1.5">
                  Email manzil
                </label>
                <input
                  type="email"
                  placeholder="Email manzilingizni kiriting"
                  className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm bg-gray-50 focus:bg-white focus:border-black focus:ring-1 focus:ring-black outline-none"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {/* Phone */}
              <div>
                <label className="text-xs font-medium text-gray-700 block mb-1.5">
                  Telefon raqami
                </label>
                <input
                  type="text"
                  value={phone}
                  readOnly
                  className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm bg-gray-50 text-gray-500 cursor-not-allowed"
                />
                <p className="mt-1 text-[11px] text-gray-400">
                  Telefon raqamini o&apos;zgartirib bo&apos;lmaydi
                </p>
              </div>

              <button
                type="submit"
                className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-md bg-gray-700 text-white text-sm font-medium py-2.5 hover:bg-gray-800 transition"
              >
                <FiUser className="w-4 h-4" />
                Profilni yangilash
              </button>
            </form>
          </section>

          {/* RIGHT – Xavfsizlik */}
          <section className="bg-white rounded-2xl border border-gray-200 shadow-sm px-6 py-6 sm:px-8 sm:py-7">
            <h2 className="text-base font-semibold text-gray-900">
              Xavfsizlik
            </h2>
            <p className="mt-1 text-xs text-gray-500">
              Hisobingizni himoya qilish uchun parolni o&apos;zgartiring
            </p>

            <form onSubmit={handlePasswordSave} className="mt-5 space-y-4">
              {/* Current password */}
              <div>
                <label className="text-xs font-medium text-gray-700 block mb-1.5">
                  Joriy parol
                </label>
                <div className="flex items-center rounded-lg border border-gray-200 bg-gray-50 px-3 py-1.5">
                  <input
                    type={showCurrent ? "text" : "password"}
                    placeholder="Joriy parolni kiriting"
                    className="flex-1 bg-transparent text-sm border-none outline-none"
                    value={currentPass}
                    onChange={(e) => setCurrentPass(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={() => setShowCurrent((v) => !v)}
                    className="text-gray-500"
                  >
                    {showCurrent ? (
                      <FiEyeOff className="w-4 h-4" />
                    ) : (
                      <FiEye className="w-4 h-4" />
                    )}
                  </button>
                </div>
              </div>

              {/* New password */}
              <div>
                <label className="text-xs font-medium text-gray-700 block mb-1.5">
                  Yangi parol
                </label>
                <div className="flex items-center rounded-lg border border-gray-200 bg-gray-50 px-3 py-1.5">
                  <input
                    type={showNew ? "text" : "password"}
                    placeholder="Yangi parolni kiriting"
                    className="flex-1 bg-transparent text-sm border-none outline-none"
                    value={newPass}
                    onChange={(e) => setNewPass(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={() => setShowNew((v) => !v)}
                    className="text-gray-500"
                  >
                    {showNew ? (
                      <FiEyeOff className="w-4 h-4" />
                    ) : (
                      <FiEye className="w-4 h-4" />
                    )}
                  </button>
                </div>
              </div>

              {/* Confirm */}
              <div>
                <label className="text-xs font-medium text-gray-700 block mb-1.5">
                  Parolni tasdiqlang
                </label>
                <div className="flex items-center rounded-lg border border-gray-200 bg-gray-50 px-3 py-1.5">
                  <input
                    type={showConfirm ? "text" : "password"}
                    placeholder="Yangi parolni takrorlang"
                    className="flex-1 bg-transparent text-sm border-none outline-none"
                    value={confirmPass}
                    onChange={(e) => setConfirmPass(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirm((v) => !v)}
                    className="text-gray-500"
                  >
                    {showConfirm ? (
                      <FiEyeOff className="w-4 h-4" />
                    ) : (
                      <FiEye className="w-4 h-4" />
                    )}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-md bg-black text-white text-sm font-medium py-2.5 hover:bg-gray-900 transition"
              >
                <FiLock className="w-4 h-4" />
                Parolni o&apos;zgartirish
              </button>
            </form>
          </section>
        </div>

        {/* Delete account button */}
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={handleDeleteAccount}
            className="inline-flex items-center gap-2 rounded-md bg-red-100 text-red-600 text-sm font-medium px-4 py-2 hover:bg-red-200"
          >
            <FiTrash2 className="w-4 h-4" />
            Hisobni o&apos;chirish
          </button>
        </div>
      </div>
    </main>
  );
}
